import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { EmptyList } from '../../../shared/empty-list/EmptyList';
import { SpinLoader } from '../../../shared/spin-loader/SpinLoader';
import TransparentButton from '../../../shared/button/transparent-button/TransparentButton';
import { ModalContainer } from '../../../shared/modal-container/ModalContainer';
import ShowIfPermission from '../../../shared/show-if-permission/ShowIfPermission';
import { PermissionEnum } from '../../../shared/models/permissions';
import '../../../shared/table/AlertsTable.scss';
import { EditClientBrandsModalContent } from './EditClientBrandsModalContent';
import { fetchClientCredentials, setClientBrands } from './redux/actions';
import { getClientCredentialsState } from './redux/selectors';
import { getBrandsAndJurisdictions } from '../../../jurisdiction/redux/selectors';
import './client-access.scss';

const headers = ['Client', 'Name', 'Kept in', 'Status', 'May send for', ''];

/*
  The client credentials, which send the events of the operators through the client API, and the brands each may send for. A
  credential is held to its brands: an event for another brand is refused, and one with no brand sends nothing.
*/
class ClientAccessContainer extends Component {
    constructor(props) {
        super(props);
        this.state = { editing: null };
        this.modalRef = React.createRef();
    }

    componentDidMount() {
        this.props.fetchClientCredentials();
    }

    edit = credential =>
        this.setState({ editing: credential }, () =>
            this.modalRef.current.openModal()
        );

    save = ({ id, brandIds }) => {
        this.props.setClientBrands({ id, brandIds });
        this.modalRef.current.closeModal();
    };

    renderBrands = credential =>
        _.isEmpty(credential.brands) ? (
            <span className={'client-access-none'}>
                No brand: sends nothing
            </span>
        ) : (
            _.map(credential.brands, brand => (
                <span key={brand.id} className={'client-access-tag'}>
                    {brand.name}{' '}
                    <span className={'sim-muted'}>{brand.jurisdiction}</span>
                </span>
            ))
        );

    renderRow = credential => (
        <tr key={credential.id} className="data">
            <td>{credential.email}</td>
            <td>
                {credential.firstName} {credential.lastName}
            </td>
            <td>{credential.provider}</td>
            <td>{credential.active ? 'Active' : 'Disabled'}</td>
            <td>{this.renderBrands(credential)}</td>
            <td className={'client-access-actions'}>
                <ShowIfPermission permission={PermissionEnum.MANAGE_USERS}>
                    <TransparentButton
                        disabled={!!this.props.busy[credential.id]}
                        onClick={() => this.edit(credential)}
                    >
                        Edit brands
                    </TransparentButton>
                </ShowIfPermission>
            </td>
        </tr>
    );

    render() {
        const { credentials, loaded, brands } = this.props;

        return (
            <div className={'container client-access'}>
                <div className={'client-access-note'}>
                    A client credential sends the events of an operator through
                    the client API, for the brands it is bound to. An event for
                    another brand is refused, and a credential bound to no brand
                    sends nothing. A new credential, and a new brand, is bound
                    to nobody until it is done here.
                </div>

                <div className={'table'}>
                    <table>
                        <tbody>
                            <tr className="headers">
                                {headers.map((header, i) => (
                                    <th key={i}>{header}</th>
                                ))}
                            </tr>
                            {!loaded ? (
                                <tr>
                                    <td colSpan={headers.length}>
                                        <SpinLoader />
                                    </td>
                                </tr>
                            ) : _.isEmpty(credentials) ? (
                                <tr className="data">
                                    <td
                                        colSpan={headers.length}
                                        style={{ textAlign: 'center' }}
                                    >
                                        <EmptyList />
                                    </td>
                                </tr>
                            ) : (
                                credentials.map(this.renderRow)
                            )}
                        </tbody>
                    </table>
                </div>

                <ModalContainer
                    ref={this.modalRef}
                    title={'Brands of the credential'}
                    content={
                        <EditClientBrandsModalContent
                            credential={this.state.editing}
                            brands={brands}
                            onSave={this.save}
                            onCancel={() => this.modalRef.current.closeModal()}
                        />
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { data, loaded, busy } = getClientCredentialsState(state);

    return {
        credentials: data,
        loaded,
        busy,
        brands: _.get(getBrandsAndJurisdictions(state), 'brands', [])
    };
};

const mapDispatchToProps = dispatch => ({
    fetchClientCredentials: () => dispatch(fetchClientCredentials()),
    setClientBrands: args => dispatch(setClientBrands(args))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClientAccessContainer);
